import { Card, Skeleton, Steps } from "antd";
import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import DefectTreeEditor from "@/components/FormEngine/Editor/SeverityGrid/DefectTreeEditor";
import SeverityGridsListTable from "@/components/FormEngine/Editor/SeverityGrid/SeverityGridsListTable";
import TranslationEditor from "@/components/FormEngine/Editor/SeverityGrid/TranslationEditor";

const SeverityGridEditor = ({
  assetTypeId,
  defectTree,
  translation,
  onUpdateTranslation,
  onUpdateDefectTree,
  loading = false,
  resetKey,
}) => {
  const { t } = useTranslation();
  const [severityGridStep, setSeverityGridStep] = useState(1);

  if (!assetTypeId) {
    return (
      <Card>
        <Skeleton />
      </Card>
    );
  }

  return (
    <Card>
      <Steps
        onChange={setSeverityGridStep}
        size="small"
        initial={1}
        titlePlacement="vertical"
        current={severityGridStep}
        type="dot"
        style={{ marginBottom: "1rem" }}
        items={[
          { title: t("form:severityGridEditor.steps.defectTreeEditor") },
          { title: t("form:severityGridEditor.steps.translation") },
          { title: t("form:severityGridEditor.steps.severityGridsListTable") },
        ]}
      />
      {severityGridStep === 1 && (
        <DefectTreeEditor
          key={resetKey}
          tree={defectTree}
          onUpdate={onUpdateDefectTree}
          loading={loading}
        />
      )}
      {severityGridStep === 2 && (
        <TranslationEditor
          key={resetKey}
          translations={translation}
          onUpdate={onUpdateTranslation}
          loading={loading}
        />
      )}
      {severityGridStep === 3 && (
        <SeverityGridsListTable
          key={resetKey}
          defectTree={defectTree}
          assetTypeId={assetTypeId}
        />
      )}
    </Card>
  );
};

SeverityGridEditor.propTypes = {
  assetTypeId: PropTypes.number,
  defectTree: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  translation: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onUpdateDefectTree: PropTypes.func,
  onUpdateTranslation: PropTypes.func,
  loading: PropTypes.bool,
  resetKey: PropTypes.number,
};

export default SeverityGridEditor;
